module.exports = __webpack_public_path__ + "img/闭嘴.4ed4ca2b.png";